// common
export const RESET_STATE = 'reset'

// --
export const SET_USER = 'set'
export const SET_USER_DIRTY = 'setDirty'
export const SET_USER_PROPS = 'setProps'
export const SET_USER_INFO_PROPS = 'setInfoProps'
export const SET_USER_PASSWORD = 'setPassword'
